import React, { useRef, useState } from 'react';
import { data } from './productData';
import {
  DetailSection,
  DisplayColumn,
  DisplayImgContainer,
  FeatureItem,
  FeatureList,
  KnowMoreBtn,
  ProductDisplaySection,
} from './styled';
import Image from 'next/image';
import { images } from '../../../Constants/ImageUrls';
import { clickedCardInSectionEvent, clickedKnowMoreEvent } from './utils';
import {
  createRippleEffectRelative,
  removeDefaultParams,
} from '../../../Utils/helper';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { getSearchParams } from '../../Parenting/common';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';

const DisplayProduct = () => {
  const btnRef = useRef();
  const router = useRouter();
  const [focusElement, setFocusElement] = useState(null);
  return (
    <ProductDisplaySection>
      <DisplayColumn order={1}>
        <DetailSection>
          <h2>{data.title}</h2>
          <p>{data.description}</p>
          <span>{data.featureText}</span>
        </DetailSection>

        <FeatureList>
          {data.features.map((feature, index) => {
            return (
              <FeatureItem key={feature + index}>
                <img src={images.checkGreen} alt="" />
                <p>{feature}</p>
              </FeatureItem>
            );
          })}
        </FeatureList>
        <KnowMoreBtn
          ref={btnRef}
          onClick={(e) => {
            createRippleEffectRelative(e, btnRef.current);
            setTimeout(() => {
              router.push(data.deeplink + getSearchParams(), '', {
                locale: getRouterLocale(router),
              });
              clickedKnowMoreEvent(data.buttonCTA, data.title);
            }, 100);
          }}
        >
          {data.buttonCTA}
        </KnowMoreBtn>
        {/* <ProductInfoSection>
                    <h3>{data.detailHeading}</h3>
                    <ProductsList>
                        {data.products.map((product, index) => {
                            return (
                                <Link
                                    key={"product" + index}
                                    href={{
                                        pathname: product.webUrl,
                                        query: removeDefaultParams(
                                            router.query,
                                        ),
                                    }}
                                    locale={false}
                                    passHref
                                >
                                    <ProdCard
                                        as="a"
                                        className={
                                            focusElement === index
                                                ? "lowOpacity"
                                                : ""
                                        }
                                        onClick={(e) => {
                                            setFocusElement(index);
                                            setTimeout(() => {
                                                e.preventDefault();
                                                router.push(
                                                    product.webUrl +
                                                        getSearchParams(),
                                                    "",
                                                    {
                                                        locale: getRouterLocale(
                                                            router,
                                                        ),
                                                    },
                                                );
                                                clickedCardInSectionEvent(
                                                    product.webUrl,
                                                    "product",
                                                    product.name,
                                                    product.id,
                                                    data.title,
                                                );
                                                setFocusElement(null);
                                            }, 200);
                                        }}
                                    >
                                        <img src={product.imgUrl} alt="" />
                                        <p>{product.name}</p>
                                    </ProdCard>
                                </Link>
                            );
                        })}
                    </ProductsList>
                </ProductInfoSection> */}
      </DisplayColumn>
      <DisplayColumn order={2}>
        <Link
          href={{
            pathname: data.deeplink,
            query: removeDefaultParams(router.query),
          }}
          locale={false}
          passHref
          legacyBehavior
        >
          <DisplayImgContainer
            className={focusElement === 'banner' ? 'lowOpacity' : ''}
            onClick={(e) => {
              setFocusElement('banner');
              setTimeout(() => {
                e.preventDefault();
                router.push(data.deeplink + getSearchParams(), '', {
                  locale: getRouterLocale(router),
                });
                clickedCardInSectionEvent(
                  data.deeplink,
                  'banner',
                  data.bannerName,
                  data.bannerId,
                  data.title,
                );
                setFocusElement(null);
              }, 200);
            }}
          >
            <Image
              src={data.bannerImg}
              alt=""
              loading="lazy"
              quality={90}
              fill
              sizes="100vw"
            />
          </DisplayImgContainer>
        </Link>
      </DisplayColumn>
    </ProductDisplaySection>
  );
};

export default DisplayProduct;
